import { useEffect } from "react";
import {useMenuContext} from "../../context/menuContext/MenuContext"

//import components
import LanguageChanger from "../languageChanger/LanguageChanger";
import Menu from "../menu/Menu";

import { useTranslation } from "react-i18next";

export default function MakerPage(props) {
  const { MenuPageIndex,SetMenuPageIndex } = useMenuContext();
  const {t} = useTranslation()

  useEffect(() => {
    SetMenuPageIndex(props.index)
  },[MenuPageIndex])

  return (<>
    <Menu />
    <LanguageChanger />  
    <div className="MakerPage">
      <div className="title">
        <img className="iconTitle" src={props.iconPath.hover} alt={props.title} /> 
        <span className="text">
          {props.title}
        </span>
      </div>
      <div className="ContentPage" style={props.styleContents}>
        {/* {t("message")} */}
        {props.children}
      </div>
      
    </div>
  </>);
}